import { useEffect, useState } from "react";
import FolderIcon from "@mui/icons-material/Folder";
import { TextField, MenuItem } from "@mui/material";
import AddItemDialog from "../../Dialogs/AddItemDialog";

const MoveFolderDialog = ({
  open,
  paths,
  pathString,
  selectedFolderName,
  handleCancel,
  moveFolder,
}: {
  open: boolean;
  paths: {} | null;
  pathString: string;
  selectedFolderName: string;
  handleCancel: () => void;
  moveFolder: (targetPath: string) => void;
}) => {
  const currentPath = !pathString || pathString === "" ? "/" : pathString;
  const [targetPath, setTargetPath] = useState(currentPath);
  const [keys, setKeys] = useState<string[] | null>(null);

  useEffect(() => {
    if (paths) {
      const selectedPath = currentPath === "/" ? `/${selectedFolderName}` : `${pathString}/${selectedFolderName}`;

      const filteredKeys = Object.keys(paths)
        .filter((key) => key !== currentPath)
        .filter((key) => key !== selectedPath)
        .filter((key) => !key.startsWith(selectedPath + "/"))
        .sort();

      setKeys(filteredKeys);
      setTargetPath(filteredKeys[0]);
    }
  }, [selectedFolderName, paths]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={handleCancel}
      handleConfirm={() => moveFolder(targetPath)}
      title={"Ordner verschieben"}
      description={"Wohin soll der Ordner verschoben werden?"}
      confirmText={"Verschieben"}
      confirmAllowed={targetPath !== currentPath}
    >
      <TextField
        margin="dense"
        id="targetPath"
        label="Zielpfad"
        color="primary"
        select
        style={{ width: "100%" }}
        value={targetPath}
        error={currentPath === targetPath}
        onChange={(e) => setTargetPath(e.target.value)}
        onKeyDown={(e) => {
          if (e.code === "Enter" && targetPath !== currentPath) moveFolder(targetPath);
        }}
      >
        {keys &&
          keys.map((k) => (
            <MenuItem key={k} value={k}>
              <FolderIcon style={{ marginBottom: "-2px", marginRight: "10px" }} />
              {k}
            </MenuItem>
          ))}
      </TextField>
    </AddItemDialog>
  );
};

export default MoveFolderDialog;
